export const EcommerceUrlReturnCodes = {
  SUCCESS: "0",
  REJECTED: "1",
  CANCELED: "2",
  ERROR: "3",
  PAYMENT_PENDING: "4",
};
